import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription, Subject } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

@Injectable()
export class FormService {
  public update$ = new Subject();

  constructor(private http: HttpClient) { }

  public getFormById(id) {
    return this.http.get(`/opdrachtformulieren/${id}`);
  }

  public postFormById(id, data, ) {
    return this.http.post(`/opdrachtformulieren/${id}/vraag`, data);
  }

  public getStudentAdministrationData(id): Observable<any> {
    return this.http.get(`/opdrachtformulieren/${id}/gegevens`);
  }

  public getIsFormulierVolledigOndertekend(id): Observable<any> {
    return this.http.get(`/opdrachtformulieren/${id}/isvolledigondertekend`);
  }

  public getAdministrationDataCache(): Observable<any> {
    return this.http.get(`/opdrachtformulieren/cache`);
  }

  public postStudentAdmistrationData(id, data) {
    return this.http.post(`/opdrachtformulieren/${id}/gegevens`, data);
  }

  public getStudentSignatureData(id, type): any {
    return this.http.get(`/opdrachtformulieren/${id}/handtekening?type=${type}`);
  }

  public postStudentSignatureData(id, data) {
    return this.http.post(`/opdrachtformulieren/${id}/handtekening`, data)
      .pipe(
        map((items) => {
          this.update$.next();
          return items;
        })
      );
  }

  public postStudentSignatureLaterData(id) {
    return this.http.post(`/opdrachtformulieren/${id}/laterondertekenen`, {})
      .pipe(
        map((items) => {
          this.update$.next();
          return items;
        })
      );
  }

  public getStudentAttachmentById(formId, id) {
    return this.http.get(`/opdrachtformulieren/${formId}/bijlagen/${id}`);
  }

  public postStudentAttachment(id, data) {
    return this.http.post(`/opdrachtformulieren/${id}/bijlagen`, data);
  }

  public deleteStudentAttachmentById(formId, id) {
    return this.http.delete(`/opdrachtformulieren/${formId}/bijlagen/${id}`);
  }

  public closeForm(formId) {
    return this.http.post(`/opdrachtformulieren/${formId}/gereed`, {});
  }

  public getStartedForms() {
    return this.http.get('/opdrachtformulieren');
  }
}



// WEBPACK FOOTER //
// ./src/app/form.service.ts